import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode, EngagementExternalRoleId, StaffRoleId } from '@interfaces';
import { EngagementEditorDialog, EngagementEditorDialogData } from '../../../dialog/engagement-editor/engagement-editor.dialog';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';



export function getButtons(pageService: AccApplicationDialogDataService, dialog: DialogService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add engagement request',
			execute: async () => {
				const personId = pageService.dialogData()?.details.participant?.personId;

				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.ADD,
					staffRoleId: StaffRoleId.EnrollmentCoordinator,
					externalRoleId: EngagementExternalRoleId.Entrepreneur,
					personId: personId
				};

				const dialogAction = await dialog.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the created engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await pageService.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				await pageService.reloadData();
			}
		},
	];

	return buttons;
}